import { Employee } from '../models/employee.model';

export const displayUserName = (user: Employee): string => {
  return `${user.lastname ? `${user.lastname}, ` : ''}${user.name}`;
};
